import { render, staticRenderFns } from "./printDelevary.vue?vue&type=template&id=28df8652"
import script from "./printDelevary.vue?vue&type=script&lang=js"
export * from "./printDelevary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports